import { store } from '@/redux/store'

import { w3Api } from '../w3Api'
import { TypeInviteCode } from './auth.type'
import { IProfile } from '../profile/profile.type'

export const authEndpoints = {
  linkAccount: '/oauth/link-account',
  disconnectLinkAccountX: '/user/social/disconnect',
  inviteCode: '/auth/register-with-invite-code',
  getCodeByEmail: '/auth/email/get-verify-code',
  linkWallet: '/auth/wallet/link-request',
  linkConfirm: '/auth/wallet/link-confirm',
}
const authW3Api = w3Api.injectEndpoints({
  endpoints: (build) => ({
    linkAcount: build.query<
      any,
      {
        provider: 'twitter' | 'discord' | 'telegram'
        redirectUri: string | undefined
      }
    >({
      query: (args) => {
        return {
          url: `${authEndpoints.linkAccount}`,
          params: args,
        }
      },
    }),
    disconnectLinkAccountX: build.mutation<any, { provider: 'twitter' | 'discord' | 'telegram' }>({
      query: (args) => {
        return {
          url: authEndpoints.disconnectLinkAccountX,
          method: 'DELETE',
          body: args,
        }
      },
      invalidatesTags: () => {
        const state = store.getState()
        const creator = state.root.auth.user?.id
        return [{ type: 'Profile', id: creator }]
      },
    }),
    getCodeByEmail: build.mutation<any, { email: string }>({
      query: (args) => {
        return {
          url: authEndpoints.getCodeByEmail,
          method: 'POST',
          body: args,
        }
      },
    }),

    inviteCode: build.mutation<IProfile, TypeInviteCode>({
      query: (args) => {
        return {
          url: authEndpoints.inviteCode,
          method: 'POST',
          body: args,
        }
      },
    }),

    linkWallet: build.mutation<IProfile, { address: string }>({
      query: (args) => {
        return {
          url: authEndpoints.linkWallet,
          method: 'POST',
          body: args,
        }
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useLazyLinkAcountQuery,
  useDisconnectLinkAccountXMutation,
  useGetCodeByEmailMutation,
  useInviteCodeMutation,
  useLinkWalletMutation,
} = authW3Api
